<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'1200px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"

    >
      <template #body >
        <div class="scanContainer">
          <h3 class="dialogTitle">Quét văn bản</h3>
          <div class="scanBody">
            <select id="sources"  class="input-font__bold input-border__bottom input-border__radius__0"></select>
            <el-button class="dialogBtnPrimary" @click="acquireImage()">
              <i :class="'fas fa-print'"></i>
              &nbsp;Scan</el-button>
            <el-button class="dialogBtnPrimary" @click="openImage()">
              <i :class="'fas fa-file-upload'"></i>
              &nbsp;Chọn</el-button>
            <el-button class="dialogBtnPrimary" @click="cleanDocument()">
              <i :class="'fas fa-backspace'"></i>
              &nbsp;Clean</el-button>
            <el-button class="dialogBtnPrimary" @click="uploadMainDocument()">
              <i :class="'fas fa-save'"></i>
              &nbsp;Lưu</el-button>
            <br/>
            <br/>
            <el-input
              type="textarea"
              autosize
              v-focus="true"
              v-model="fileName"
              placeholder="* Tên tài liệu"
              maxlength="2000"
              size="large"
              class="input-font__bold style-fullWidth docBigTitle"
              v-if="hasSource"
            />
            <div class="content" v-bind:id="containerId"></div>

          </div>
        </div>


      </template>
      <template #footer>
      </template>
    </dialogTemplate>
  </div>
</template>

<script>

import Dynamsoft from "dwt";
import httpService from "../../services/httpService";
import { Loading } from 'element-ui';
import systemConfigService from "../../services/systemConfigService";
import constants from "../../constants";
const path = require('path');


export default {
  name: "scan-dialog",
  props: ["isOpen","objectType"],
  filters: {},
  components: {
    dialogTemplate: () => import("../common/custom-dialog.vue")
  },
  mounted() {
    this.initScanLib();
  },
  mixins: [],
  data() {
    return {
      option:null,
      options:[],
      containerId: "dwtControlContainer",
      bWASM: true,
      hasSource:false,
      fileName:null,
      aryIndicesTags: []
    }
  },

  computed: {},

  created() {
    // this.initFileName();
    this.initScanFileName();
  },

  methods: {
    initScanFileName(){
      systemConfigService.getScanFileName().then(
        (response)=>{
          this.fileName=response.data;
        }
      );
    },
    initScanLib(){
      this.bWASM = Dynamsoft.Lib.env.bMobile || Dynamsoft.WebTwainEnv.UseLocalService;
      console.log("bWASM",this.bWASM);
      /**
       * ResourcesPath & ProductKey must be set in order to use the library!
       */
      Dynamsoft.WebTwainEnv.ResourcesPath = path.join(__dirname, '../../../static/dwt-resources');
      // Dynamsoft.WebTwainEnv.ProductKey =
      //   "t0068MgAAAJCtoPQCHphc8EjbjXjN+mTlyo/8etwp3pdGjpb0sHLVJJM2GEqTIOSkeGoJsV8sYJ7tpdlNV+wcRzj9K4mybmo=";
      Dynamsoft.WebTwainEnv.ProductKey = constants.DYNAMIC_WEB_TWAIN_KEY;
      Dynamsoft.WebTwainEnv.Containers = [{
        WebTwainId: "dwtObject",
        ContainerId: this.containerId,
        Width: "1130px",
        Height: "1130px",
      },];
      Dynamsoft.WebTwainEnv.RegisterEvent("OnWebTwainReady", () => {
        this.Dynamsoft_OnReady();
      });
      Dynamsoft.WebTwainEnv.Load();
    },

    initFileName(){
      let today = new Date();
      this.fileName="document_"+today.getDate()+"_"+today.getMonth()+"_"+today.getFullYear()+"_"+today.getSeconds()+"_"+today.getMinutes()+"_"+today.getHours();
    },
    /**
     * Dynamsoft_OnReady is called when a WebTwain instance is ready to use.
     * In this callback we do some initialization.
     */
    Dynamsoft_OnReady() {

      this.DWObject = Dynamsoft.WebTwainEnv.GetWebTwain(this.containerId);
      let sources = this.DWObject.GetSourceNames();
      for (let i = 0; i < sources.length; i++) {
        this.options.push({
          index:i,
          name:sources[i]
        })
      }
      this.selectSources = document.getElementById("sources");
      this.selectSources.options.length = 0;
      for (let i = 0; i < sources.length; i++) {
        this.selectSources.options.add(new Option(sources[i], i.toString()));
      }
    },
    /**
     * Acquire images from scanners or cameras or local files
     */
    acquireImage() {
      if (!this.DWObject) this.DWObject = Dynamsoft.WebTwainEnv.GetWebTwain();
      else if (
        this.DWObject.SourceCount > 0 &&
        this.DWObject.SelectSourceByIndex(this.selectSources.selectedIndex)
      ) {
        const onAcquireImageSuccess = () => {
          this.DWObject.CloseSource();
          this.tagDocument();
          // console.log(this.DWObject.ErrorString);

        };
        const onAcquireImageFailure = onAcquireImageSuccess;
        this.DWObject.OpenSource();
        this.DWObject.AcquireImage({},
          onAcquireImageSuccess,
          onAcquireImageFailure
        );
        this.hasSource=true;

      } else {
        this.hasSource=false;
        alert("No Source Available!");
      }
    },
    /**
     * Open local images.
     */
    openImage() {
      if (!this.DWObject) this.DWObject = Dynamsoft.WebTwainEnv.GetWebTwain();
      this.DWObject.IfShowFileDialog = true;
      /**
       * Note, this following line of code uses the PDF Rasterizer which is an extra add-on that is licensed seperately
       */
      this.DWObject.Addon.PDF.SetConvertMode(
        Dynamsoft.EnumDWT_ConvertMode.CM_RENDERALL
      );

      this.DWObject.LoadImageEx(
        "",
        Dynamsoft.EnumDWT_ImageType.IT_ALL,
        () => {
          this.hasSource=true;
          this.tagDocument();
          //success
        },
        () => {
          //failure
          console.log(console.log(this.DWObject.ErrorString))
          this.hasSource=false;
        }
      );

    },

    tagDocument() {
      // let count=0;
      let flag = true;
      let aryIndice = [];
      for (let i = 0; i < this.DWObject.HowManyImagesInBuffer; i++) {
        if (this.DWObject.IsBlankImage(i)) {
          this.aryIndicesTags.push(aryIndice);
          aryIndice = [];
          // count++;
          flag = false;
        }
        // this.DWObject.TagImages([i], "document_"+count);
        if (flag) {
          aryIndice.push(i);
        } else {
          flag = true;
        }
      }
      this.aryIndicesTags.push(aryIndice);

    },
    cleanDocument(){
      this.fileName=null;
      this.hasSource=false;
      this.aryIndicesTags=[];
      this.initScanLib();
    },
    uploadMainDocument() {
      console.log("aryIndicesTags.length",this.aryIndicesTags.length)
      if(this.aryIndicesTags.length<=0){
        this.message("Thông báo", "Chưa tìm thấy văn bản scan ", "warning", 2000);
        return;
      }
      if((this.fileName.toString()=="")){
        this.message("Thông báo", "Chưa đặt tên cho văn bản đính kèm", "warning", 2000);
        return;
      }
      // if((this.fileName.toString()=="")){
      //   this.message("Thông báo", "Văn bản đính kềm chưa tồn tại hoặc chưa được đặt tên !", "warning", 2000);
      //   return;
      // }
      if(this.aryIndicesTags.length >0){
        let loadingInstance = Loading.service({});
        this.DWObject.ConvertToBlob(this.aryIndicesTags[0], Dynamsoft.EnumDWT_ImageType.IT_PDF, (_blob, newIndices, enumImageType, _arguments) => {
            let fd = new FormData();
            fd.append('file', _blob);
            fd.append('objectType', this.objectType);
            fd.append('fileName', this.fileName+".pdf");
            httpService.post('attachment/uploadFileScanFile', fd).then((response)=>{
              loadingInstance.close();
              this.$emit("success",{attachment:response.data});
            })
          }, (error) => {
             loadingInstance.close();
            console.log(error);
          }
        );
      }else {

      }

    },

    cancel() {
      this.$emit("closeDialog");
    },
    success(){
      this.$emit("success");
    }
  }
}


</script>

<style scoped>
/*.content {*/
/*  height: 300px;*/
/*}*/
.scanContainer{
  height: 850px;
}
#sources{
  height: 35px;
  border: 1px solid #7a7a7f;
  border-radius: 1px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/scan-dialog.vue